import React, { useState, useEffect } from "react";
// Import the structured content JSON file
import structuredContent from "./content.json";

const SearchComponent = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);

  // Search logic
  const searchContent = (term) => {
    if (!term) {
      setResults([]);
      return;
    }

    console.log("Structured Content:", structuredContent);

    const lowerCaseTerm = term.toLowerCase();

    // Ensure `structuredContent` is valid and properly structured
    if (!Array.isArray(structuredContent)) {
      console.error("Invalid content structure. Expected an array.");
      setResults([]);
      return;
    }

    const searchResults = structuredContent
      .map((chapter) => {
        if (!chapter.content || !Array.isArray(chapter.content)) {
          console.warn(`Invalid content in chapter: ${chapter.chapter}`);
          return null;
        }

        // Filter for matches in content
        const matches = chapter.content.filter((entry) =>
          entry.toLowerCase().includes(lowerCaseTerm)
        );

        if (matches.length > 0) {
          return {
            chapter: chapter.chapter,
            matches: matches.map((match, idx) => ({
              line: chapter.content.indexOf(match) + 1, // Ensure correct line index
              text: match,
            })),
          };
        }

        return null;
      })
      .filter(Boolean); // Remove null entries

    setResults(searchResults);
  };

  // Trigger search when the searchTerm changes
  useEffect(() => {
    searchContent(searchTerm);
  }, [searchTerm]);

  
  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h1>Search Content</h1>
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "20px",
          fontSize: "16px",
        }}
      />
      <div>
        {results.length > 0 ? (
          results.map((result, index) => (
            <div key={index} style={{ marginBottom: "20px" }}>
              <h2>{result.chapter}</h2>
              <ul>
                {result.matches.map((match, idx) => (
                  <li key={idx}>
                    <strong>Line {match.line}:</strong> {match.text}
                  </li>
                ))}
              </ul>
            </div>
          ))
        ) : (
          searchTerm && <p>No results found for "{searchTerm}".</p>
        )}
      </div>
    </div>
  );
};

export default SearchComponent;
